module.exports = __webpack_public_path__ + "media/images/pic/saska/polygon_news_smaller-311451539adceaddbf5ac8c5253fc09f.png";